import React from "react";
import { Mail, Calendar, Megaphone } from "lucide-react";
import { problems } from "../mock";

const iconMap = { Mail, Calendar, Megaphone };

const Problem = () => {
  return (
    <section className="bg-black py-20 md:py-28 relative overflow-hidden">
      <div
        className="absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full blur-3xl opacity-20"
        style={{ background: "radial-gradient(circle, #14b8a6 0%, transparent 70%)" }}
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-xs uppercase tracking-[0.18em] text-teal-400 font-medium">
          The real problem
        </div>
        <h2 className="mt-4 text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-white leading-[1.05] max-w-4xl">
          The problem isn&apos;t effort.{" "}
          <em className="text-teal-300 font-serif font-normal">
            It&apos;s fragmentation.
          </em>
        </h2>
        <p className="mt-5 text-white/60 text-lg max-w-2xl">
          When your tools don&apos;t connect, your people fall through the
          gaps. Fragmentation is the enemy of flourishing.
        </p>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {problems.map((p) => {
            const Icon = iconMap[p.icon];
            return (
              <div
                key={p.title}
                className="group relative rounded-2xl border border-white/10 bg-white/[0.03] p-8 hover:border-teal-400/40 hover:bg-white/[0.05] transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-teal-500/10 border border-teal-400/30 flex items-center justify-center text-teal-300 group-hover:bg-teal-500/20 transition-colors">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="mt-6 text-xl font-semibold text-white">
                  {p.title}
                </h3>
                <p className="mt-3 text-white/60 leading-relaxed">{p.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Problem;
